import React from "react";
import './brochure.css';
import ModalImage from "react-modal-image";

function Brochure() {
    return (
        <div style={{textAlign: 'center', background: '#D1D5DB', padding: '3vmax 10vmax'}}>
            <h2 className="compTitle">Conference Brochure</h2>
            <div className="broImg">
                <ModalImage 
                    small="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Brochure/A4_-_1_dpVheDbHp.svg?updatedAt=1679980677782"
                    large="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Brochure/A4_-_1_dpVheDbHp.svg?updatedAt=1679980677782" 
                    alt="Brochure Page 1"
                />
                <ModalImage 
                    small="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Brochure/A4_-_2_EF4Zy4E_h.svg?updatedAt=1679980679258"
                    large="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Brochure/A4_-_2_EF4Zy4E_h.svg?updatedAt=1679980679258" 
                    alt="Brochure Page 1"
                />
            </div>
        </div>
    )
}

export default Brochure;